import * as React from 'react'
import { CodeBlock } from '../../ui/codeBlock'
import { Alert } from '../../ui/alert'
import Percent from '../../helper/percent'
import LargeNumber from '../../helper/large-number'

interface Props {
    message?: {
        args: {
            ratio: number
            findFile: number
            findFileWithExtension: number
        }
    }
}

const code = `# level 1: optimize
composer dump-autoload --optimize

# level 2a: authoritative class map
composer dump-autoload --classmap-authoritative
# level 2b: APCu cache
composer dump-autoload --apcu   
`

export default class ComposerAutoloadOptimization extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        let intro = <p>We found traces where composer&apos;s autoloader can be further optimized.</p>

        if (message) {
            const { args } = message

            intro = (
                <p>
                    The composer autoloader used in this trace can be further optimized.
                    <br />
                    <LargeNumber value={args.findFileWithExtension} /> / <LargeNumber value={args.findFile} /> Classes (
                    <Percent value={args.ratio} />) triggered additional file I/O.
                </p>
            )
        }

        return (
            <>
                <div>
                    {intro}
                    <p>
                        For production systems we recommend enabling autoload optimization level 1. <br />
                        The following commands show the different optimization options:
                    </p>
                    <CodeBlock language="bash" code={code} />
                </div>
                <Alert level="warning">
                    <p>
                        With level 2 optimizations there are trade-offs to consider: Authoritative class map does not work with classes
                        generated at runtime, APCu requires the php-apcu extension to be present. Please check out composer&apos;s{' '}
                        <a href="https://getcomposer.org/doc/articles/autoloader-optimization.md">official documentation</a> for more
                        details.
                    </p>
                </Alert>
            </>
        )
    }
}
